// 윤회의 문 UI(레인 R, REBIRTH-MODES-SPEC 2.1): 다가가면 상호작용 안내(E/터치), 열리면 확인 화면 — 모드 카드 3장, 유지·초기화 목록,
// 보상 줄, 「환생하기」 → 한 번 더 확인. 환생 뒤 새 모드 소개 카드(ARPG면 필드 입구 안내 — 필드는 레인 F 몫).
// 콘셉트: concept/stage-maps-20261023/ui-rebirth.webp(오른쪽 패널). 게임 상태는 읽기만 하고 변경은 명령·InputSink로만 한다.
import { Btn, Scene, type GameCommand, type GameView, type InputSink } from '../shared/types';
import { STAR2_INTRO, MODE_INTRO, REBIRTH_KEEPS, REBIRTH_RESETS, REBIRTH_DENIAL_TEXT, modeOfCycle, rebirthLook } from '../shared/rebirth';
import { FONT, el } from './dom';
import { makeRequestId } from './rpgModel';
import { modeCards, rewardChips } from './rebirthModel';

const STYLE_ID = 'dh-rebirth-style';
const CSS = `
.dh-rb{position:absolute;inset:0;pointer-events:none;font-family:${FONT};color:#f1f3f9}
.dh-rb-prompt{position:absolute;left:50%;bottom:calc(96px + env(safe-area-inset-bottom));transform:translateX(-50%);pointer-events:auto;cursor:pointer;touch-action:none;min-height:52px;padding:10px 26px;border-radius:26px;border:2px solid #9fc0ff;background:linear-gradient(180deg,rgba(26,40,82,.96),rgba(12,18,40,.96));color:#fff;font:800 20px ${FONT};white-space:nowrap;box-shadow:0 0 0 4px rgba(9,12,26,.6),0 0 18px rgba(120,160,255,.45)}
.dh-rb-back{position:absolute;inset:0;z-index:45;display:flex;align-items:center;justify-content:flex-end;padding:max(8px,env(safe-area-inset-top)) max(12px,env(safe-area-inset-right)) max(8px,env(safe-area-inset-bottom)) 12px;pointer-events:auto;background:linear-gradient(90deg,rgba(6,8,18,.15),rgba(6,8,18,.55));touch-action:none}
.dh-rb-win{position:relative;width:min(640px,calc(100vw - 24px));max-height:100%;display:flex;flex-direction:column;overflow:hidden;box-sizing:border-box;padding:14px 16px 16px;border-radius:14px;border:2px solid #c9a75a;background:linear-gradient(170deg,rgba(20,28,52,.97),rgba(9,13,28,.98));box-shadow:0 10px 40px #000a,inset 0 0 0 3px #0a1222}
.dh-rb-body{flex:1 1 auto;min-height:0;overflow:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}
.dh-rb-foot{flex:none;padding-top:2px}
.dh-rb-title{flex:none;text-align:center;font:900 30px ${FONT};color:#ffe08a;letter-spacing:1px;text-shadow:0 2px 0 #000,0 0 18px rgba(242,193,78,.45);margin:2px 40px 10px}
.dh-rb-x{position:absolute;right:10px;top:10px;min-width:44px;min-height:44px;border-radius:8px;border:1px solid #b99c60;background:#122039;color:#f0eee7;font:800 18px ${FONT};cursor:pointer}
.dh-rb-cards{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}
.dh-rb-card{position:relative;min-height:128px;border-radius:10px;border:2px solid #6c5a33;padding:10px 6px 34px;text-align:center;overflow:hidden}
.dh-rb-card b{display:block;font-size:17px}.dh-rb-card strong{display:block;font-size:22px;margin-top:4px;color:#fff3c8}
.dh-rb-card .glyph{display:block;font-size:34px;line-height:40px;color:#ffe7a0;text-shadow:0 0 14px rgba(255,220,140,.7)}
.dh-rb-card .badge{position:absolute;left:8px;right:8px;bottom:8px;font-size:14px;font-weight:800;color:#d8e2f6}
.dh-rb-card.next{border-color:#ffd56a;box-shadow:0 0 18px rgba(255,210,100,.55),inset 0 0 0 1px #fff2b8}.dh-rb-card.next .badge{color:#2a1d05;background:linear-gradient(180deg,#ffe597,#e1a536);border-radius:6px;padding:2px 0}
.dh-rb-card.locked{filter:grayscale(.55) brightness(.75)}.dh-rb-card.done .badge::before{content:'✓ ';color:#7fe3a0}
.dh-rb-row{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:10px}
.dh-rb-box{border:1px solid #4b5f80;border-radius:8px;padding:8px 10px;background:rgba(10,16,32,.7);font-size:14px;line-height:1.5}
.dh-rb-box b{color:#ffe08a}.dh-rb-box.reset b{color:#ff8a8a}
.dh-rb-sub{text-align:center;margin:12px 0 6px;color:#e8cd86;font-weight:800}
.dh-rb-rewards{display:grid;grid-template-columns:repeat(4,1fr);gap:8px}
.dh-rb-rew{border:1px solid #8a7440;border-radius:8px;padding:8px 4px;text-align:center;background:linear-gradient(180deg,#1b2440,#10162a);font-size:13px;font-weight:700}
.dh-rb-rew i{display:block;font-style:normal;font-size:24px;color:#ffd56a}
.dh-rb-go{display:block;width:100%;min-height:58px;margin-top:14px;border-radius:12px;border:2px solid #fff1b8;background:linear-gradient(180deg,#ffe597,#d99a2c);color:#2a1d05;font:900 26px ${FONT};letter-spacing:2px;cursor:pointer;box-shadow:0 0 22px rgba(242,193,78,.5)}
.dh-rb-go:disabled{filter:grayscale(.8) brightness(.7);cursor:not-allowed;box-shadow:none}
.dh-rb-deny{margin-top:8px;text-align:center;color:#ffc9a8;font-size:14px}
.dh-rb-confirm{margin-top:12px;padding:10px;border-radius:10px;border:1px solid #ff8a8a;background:rgba(60,14,20,.6);text-align:center;font-weight:800;line-height:1.5}
.dh-rb-confirm .row{display:flex;gap:8px;justify-content:center;margin-top:8px}
.dh-rb-btn{min-height:48px;min-width:120px;border-radius:8px;border:1px solid #b99c60;background:#122039;color:#f5df9f;font:800 17px ${FONT};cursor:pointer}
.dh-rb-btn.pri{background:linear-gradient(180deg,#ffe597,#d99a2c);color:#2a1d05;border-color:#fff1b8}
.dh-rb-msg{margin-top:8px;text-align:center;font-size:14px;min-height:20px}
.dh-rb-intro{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:46;pointer-events:auto;width:min(520px,calc(100vw - 32px));box-sizing:border-box;padding:18px 18px 16px;border-radius:14px;border:2px solid #9fc0ff;background:linear-gradient(170deg,rgba(18,30,66,.97),rgba(8,12,28,.98));box-shadow:0 10px 40px #000a,0 0 30px rgba(110,150,255,.35);text-align:center}
.dh-rb-intro h3{margin:0 0 4px;font:900 15px ${FONT};color:#9fc0ff;letter-spacing:2px}.dh-rb-intro h2{margin:0 0 10px;font:900 26px ${FONT};color:#ffe08a}
.dh-rb-intro p{margin:6px 0;font-size:15px;line-height:1.55}.dh-rb-intro p.hl{color:#ffe08a;font-weight:800}
@media (max-height:480px){.dh-rb-win{padding:8px 12px 10px}.dh-rb-go{margin-top:6px}.dh-rb-confirm{margin-top:6px;padding:6px}.dh-rb-confirm .row{margin-top:4px}.dh-rb-msg{margin-top:4px;min-height:0}.dh-rb-deny{margin-top:4px}.dh-rb-title{font-size:22px;margin-bottom:6px}.dh-rb-card{min-height:96px;padding-bottom:28px}.dh-rb-card .glyph{font-size:24px;line-height:28px}.dh-rb-card strong{font-size:17px}.dh-rb-rew{padding:4px 2px;font-size:12px}.dh-rb-rew i{font-size:18px}.dh-rb-go{min-height:48px;font-size:21px;margin-top:8px}.dh-rb-row{margin-top:6px}.dh-rb-box{padding:5px 8px;font-size:13px}}
`;
const CARD_BG = [
  'linear-gradient(180deg,#1f4a3a,#0f241e)',
  'linear-gradient(180deg,#5a5a7a,#2a2a48 60%,#1a1630)',
  'linear-gradient(180deg,#5a1d36,#2a0c1c)',
];
const GLYPH = ['❦', '✵', '♛'];

export class RebirthUi {
  private readonly root: HTMLDivElement;
  private readonly prompt: HTMLButtonElement;
  private readonly back: HTMLDivElement;
  private readonly win: HTMLDivElement;
  private readonly intro: HTMLDivElement;
  private confirm = false;
  private held = false;
  private key = '';
  private introKey = '';
  private lastSeq = 0;
  private msg = '';
  private msgTone: 'ok' | 'warn' = 'ok';

  constructor(parent: HTMLElement, private readonly view: GameView, private readonly send: (c: GameCommand) => void, private readonly input: InputSink, private readonly touchOn: boolean) {
    if (!document.getElementById(STYLE_ID)) { const st = el('style', '', document.head); st.id = STYLE_ID; st.textContent = CSS; }
    this.root = el('div', 'display:none;', parent);
    this.root.className = 'dh-rb';
    this.root.dataset.testid = 'rebirth-root';
    this.prompt = el('button', 'display:none;', this.root);
    this.prompt.type = 'button';
    this.prompt.className = 'dh-rb-prompt';
    this.prompt.dataset.testid = 'rebirth-prompt';
    this.prompt.textContent = (touchOn ? '' : 'E ') + '윤회의 문';
    this.prompt.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      if (this.held) return;
      this.held = true;
      try { this.prompt.setPointerCapture(e.pointerId); } catch { /* 무시 */ }
      this.input.buttonDown(Btn.Interact);
    });
    const release = (): void => this.release();
    this.prompt.addEventListener('pointerup', release);
    this.prompt.addEventListener('pointercancel', release);
    this.prompt.addEventListener('lostpointercapture', release);
    this.back = el('div', 'display:none;', this.root);
    this.back.className = 'dh-rb-back';
    this.back.addEventListener('pointerdown', (e) => { if (e.target === this.back) this.close(); });
    this.back.addEventListener('wheel', (e) => e.stopPropagation(), { passive: true });
    this.win = el('div', '', this.back);
    this.win.className = 'dh-rb-win';
    this.win.dataset.testid = 'rebirth-panel';
    this.win.setAttribute('role', 'dialog');
    this.win.setAttribute('aria-modal', 'true');
    this.win.tabIndex = -1;
    this.win.addEventListener('keydown', (e) => {
      if (e.code === 'Escape') { e.preventDefault(); e.stopPropagation(); this.close(); }
      else if (e.code === 'Enter' || e.code === 'Space' || e.code === 'NumpadEnter') e.stopPropagation();
    });
    this.intro = el('div', 'display:none;', this.root);
    this.intro.className = 'dh-rb-intro';
    this.intro.dataset.testid = 'rebirth-intro';
    this.intro.setAttribute('role', 'dialog');
  }

  private release(): void { if (this.held) { this.held = false; this.input.buttonUp(Btn.Interact); } }
  private close(): void { this.confirm = false; this.send({ type: 'closeMenu' }); }

  update(): void {
    const v = this.view, r = v.rebirth, vv = v.village;
    const village = v.flow.scene === Scene.Village && !!r;
    if (!village) { if (this.root.style.display !== 'none') { this.root.style.display = 'none'; this.release(); } return; }
    if (this.root.style.display === 'none') this.root.style.display = 'block';
    if (r.last.seq !== this.lastSeq) {
      this.lastSeq = r.last.seq;
      if (r.last.kind === 'rebirth' && r.last.message) { this.msg = r.last.message; this.msgTone = r.last.code === 'ok' ? 'ok' : 'warn'; this.key = ''; }
    }
    const otherOpen = vv.menuNpc >= 0 || vv.inventoryOpen || vv.stageMapOpen || vv.questOpen;
    const open = !!vv.rebirthOpen && !v.flow.paused;
    // 안내: 문 앞, 창이 모두 닫혔을 때
    const showPrompt = !!vv.nearGate && !open && !otherOpen && !v.flow.paused;
    if ((this.prompt.style.display !== 'none') !== showPrompt) { this.prompt.style.display = showPrompt ? 'block' : 'none'; if (!showPrompt) this.release(); }
    if (!open) {
      if (this.back.style.display !== 'none') { this.back.style.display = 'none'; this.confirm = false; this.msg = ''; this.key = ''; }
    } else {
      const first = this.back.style.display === 'none';
      if (first) this.back.style.display = 'flex';
      const key = [r.revision, r.cycle, r.denial, r.introPending, this.confirm, this.msg, v.growth.level].join('|');
      if (key !== this.key) { this.key = key; this.render(); }
      if (first) this.win.focus({ preventScroll: true });
    }
    // 소개 카드: 환생 직후(창 안에서 보인다) 또는 새로 고침 뒤 아직 확인하지 않았을 때(마을, 다른 창이 없을 때)
    const showIntro = r.introPending && !otherOpen && !v.flow.paused && (open || !vv.nearGate);
    const ik = showIntro ? r.cycle + ':' + (open ? 1 : 0) : '';
    if (ik !== this.introKey) {
      this.introKey = ik;
      this.intro.style.display = showIntro ? 'block' : 'none';
      if (showIntro) this.renderIntro(open);
      if (showIntro && open) this.back.style.display = 'none';
    }
    if (showIntro && open && this.back.style.display !== 'none') this.back.style.display = 'none';
  }

  private renderIntro(inWindow: boolean): void {
    const r = this.view.rebirth!;
    const mode = r.modeId, it = r.cycle === 2 && mode === 'arpg' ? STAR2_INTRO : MODE_INTRO[mode];
    this.intro.textContent = '';
    this.intro.style.borderColor = rebirthLook(r.cycle).auraCss || '#9fc0ff';
    el('h3', '', this.intro, r.cycle + '차 환생 · 새 모드');
    el('h2', '', this.intro, it.title);
    it.lines.forEach((t, i) => { const p = el('p', '', this.intro, t); if (mode === 'arpg' && i === 1) { p.className = 'hl'; p.dataset.testid = 'rebirth-intro-field'; } });
    const ok = el('button', 'margin-top:10px;', this.intro, '확인');
    ok.type = 'button'; ok.className = 'dh-rb-btn pri'; ok.dataset.testid = 'rebirth-intro-ok';
    ok.addEventListener('click', () => {
      this.send({ type: 'rebirthIntro', requestId: makeRequestId() });
      if (inWindow) this.close();
    });
  }

  private render(): void {
    const v = this.view, r = v.rebirth!, w = this.win;
    w.textContent = '';
    const x = el('button', '', w, '✕'); x.type = 'button'; x.className = 'dh-rb-x'; x.dataset.testid = 'rebirth-close'; x.setAttribute('aria-label', '닫기');
    x.addEventListener('click', () => this.close());
    el('div', '', w, '✧ Lv.' + v.growth.level + ' → 환생 ✧').className = 'dh-rb-title';
    const body = el('div', '', w); body.className = 'dh-rb-body';
    const cards = el('div', '', body); cards.className = 'dh-rb-cards';
    for (const c of modeCards(r.cycle, r.modes)) {
      const card = el('div', 'background:' + CARD_BG[c.cycle] + ';', cards);
      card.className = 'dh-rb-card ' + c.state;
      card.dataset.testid = 'rebirth-card-' + c.cycle;
      el('span', '', card, GLYPH[c.cycle]).className = 'glyph';
      el('b', '', card, c.head);
      el('strong', '', card, c.mode);
      el('span', '', card, c.badge).className = 'badge';
    }
    const row = el('div', '', body); row.className = 'dh-rb-row';
    const keep = el('div', '', row); keep.className = 'dh-rb-box keep'; keep.dataset.testid = 'rebirth-keeps';
    el('b', '', keep, '유지 '); keep.append(REBIRTH_KEEPS.join(' · '));
    const reset = el('div', '', row); reset.className = 'dh-rb-box reset'; reset.dataset.testid = 'rebirth-resets';
    el('b', '', reset, '초기화 '); reset.append(REBIRTH_RESETS.join(' · '));
    el('div', '', body, '◇ 환생 보상 ◇').className = 'dh-rb-sub';
    const rew = el('div', '', body); rew.className = 'dh-rb-rewards';
    const foot = el('div', '', w); foot.className = 'dh-rb-foot';
    for (const c of rewardChips(r.cycle + 1)) { const b = el('div', '', rew); b.className = 'dh-rb-rew'; b.dataset.testid = 'rebirth-reward-' + c.id; el('i', '', b, c.icon); b.append(c.text); }
    if (!this.confirm) {
      const go = el('button', '', foot, '환생하기'); go.type = 'button'; go.className = 'dh-rb-go'; go.dataset.testid = 'rebirth-go';
      go.disabled = r.denial !== null || r.mode !== 'ok';
      go.addEventListener('click', () => { this.confirm = true; });
      if (r.denial) el('div', '', foot, REBIRTH_DENIAL_TEXT[r.denial]).className = 'dh-rb-deny';
      else if (r.mode !== 'ok') el('div', '', foot, '환생 기록을 읽지 못해 지금은 환생할 수 없어요.').className = 'dh-rb-deny';
    } else {
      const c = el('div', '', foot); c.className = 'dh-rb-confirm'; c.dataset.testid = 'rebirth-confirm-box';
      el('div', '', c, '정말 환생할까요? 레벨이 1이 되고 스킬 트리 포인트를 돌려받아요.');
      el('div', 'font-weight:600;color:#ffd9d0;', c, '스킬·장비·재화는 그대로, 1회차 마을·스테이지도 계속 들어갈 수 있어요.');
      const rr = el('div', '', c); rr.className = 'row';
      const yes = el('button', '', rr, '환생 확정'); yes.type = 'button'; yes.className = 'dh-rb-btn pri'; yes.dataset.testid = 'rebirth-confirm';
      yes.addEventListener('click', () => { this.confirm = false; this.send({ type: 'rebirth', requestId: makeRequestId() }); });
      const no = el('button', '', rr, '취소'); no.type = 'button'; no.className = 'dh-rb-btn'; no.dataset.testid = 'rebirth-cancel';
      no.addEventListener('click', () => { this.confirm = false; });
    }
    const m = el('div', 'color:' + (this.msgTone === 'ok' ? '#9be8b0' : '#ffc9a8') + ';', foot, this.msg); m.className = 'dh-rb-msg'; m.dataset.testid = 'rebirth-msg'; m.setAttribute('role', 'status');
  }
}
